
import { Component, Vue, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import StepsIndividual from '../StepsIndividual.vue'
import http from '@/utils/request'
import { isEmail } from '@/utils/validate'
import '../register.scss'
import { setPlatformInfo } from '@/utils/user'
import Loading from '../Loading.vue'
import { sleep } from '@/utils'
import i18n from '@/lang'

@Component({
  components: { StepsIndividual, Loading }
})
export default class Platform extends Vue {
  private validateEmail = (rule: any, value: string, callback: Function) => {
    if (!isEmail(value)) {
      callback(new Error(i18n.t('Email is not correct') as string))
    } else {
      callback()
    }
  }

  private validateConfirmPassword(rule: any, value: string, callback: Function) {
    if (value !== this.form.password) {
      callback(new Error(i18n.t('Kedua kata sandi tidak konsisten') as string))
    } else {
      callback()
    }
  }

  private registerFormRef!: ElForm
  private emailDisabled = true
  private sendMailLoading = false
  private submitLoading = false
  private submitDisabled = true
  private showLoading = false
  private loadingStatus = ''

  private form = {
    email: '',
    verCode: '',
    mobile: '',
    loginName: '',
    firstName: '',
    middleName: '',
    lastName: '',
    identity: '',
    password: '',
    confirmPassword: ''
  }

  testForm() {
    this.form.email = 'acf001@qq.com'
    this.form.mobile = '012399000'
    this.form.loginName = 'Hello'
    this.form.firstName = 'world'
    this.form.middleName = ''
    this.form.lastName = ''
    this.form.identity = '91010101010'
    this.form.password = '000000'
    this.form.confirmPassword = '000000'
  }

  private rules = {
    email: [{ validator: this.validateEmail, trigger: 'blur' }],
    confirmPassword: [{ validator: this.validateConfirmPassword, trigger: 'blur' }]
  }

  @Watch('form.email')
  onEmailChange() {
    this.registerFormRef.validateField('email', (errorMessage: string) => {
      this.emailDisabled = !!errorMessage
    })
  }

  @Watch('form', { deep: true })
  onFormChange() {
    // eslint-disable-next-line
    const { lastName, middleName, ...params } = this.form
    const valid = Object.values(params).every(
      (value) => value !== '' && value !== undefined && value !== null
    )
    this.submitDisabled = !valid
  }

  async onSubmit() {
    try {
      await this.registerFormRef.validate()

      this.submitLoading = true
      this.showLoading = true
      const params = { ...this.form }
      params.mobile = '62' + this.form.mobile
      await sleep(1500)
      const data = await http.post('/user/doRegister', params)
      if (data) {
        this.loadingStatus = 'success'
        setPlatformInfo(this.form)
        await sleep(2000)
        // After successful registration, log in
        await this.$router.push({ path: '/login' })
      } else {
        this.$notify.error({ title: i18n.t('Registration failed') as string, message: '' })
      }
    } catch (e) {
      // handle error
    } finally {
      this.submitLoading = false
      this.showLoading = false
    }
  }

  async sendMail() {
    try {
      this.sendMailLoading = true
      const { email } = this.form
      const data = await http.post('/user/sendMail', { email })
      if (data) {
        this.$notify.success({ title: 'Success', message: '' })
      }
    } catch (e) {
      // handle error
    } finally {
      this.sendMailLoading = false
    }
  }

  mounted() {
    this.registerFormRef = this.$refs.registerFormRef as ElForm
    if (process.env.NODE_ENV === 'development') {
      this.testForm()
    }
  }
}
